var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
export var Flex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-grow: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-grow: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"])), function (_a) {
    var direction = _a.direction;
    return direction || 'row';
}, function (_a) {
    var grow = _a.grow;
    return grow || 0;
}, function (_a) {
    var alignment = _a.alignment;
    return alignment || 'stretch';
}, function (_a) {
    var spacing = _a.spacing;
    return spacing || 'flex-start';
});
export var FlexVertical = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
export var SpaceBetween = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
